import { render, staticRenderFns } from "./editproducts.vue?vue&type=template&id=47bb6b85&scoped=true&"
import script from "./editproducts.vue?vue&type=script&lang=js&"
export * from "./editproducts.vue?vue&type=script&lang=js&"
import style0 from "./editproducts.vue?vue&type=style&index=0&id=47bb6b85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bb6b85",
  null
  
)

export default component.exports